<template>
    <span class="file-drop-zone"
          @drop.prevent="dropped"
          @dragenter.prevent="activate"
          @dragover.prevent="activate"
          @dragleave.prevent="deactivate"
    >
        <slot/>
    </span>
</template>

<script lang="ts" setup>
import { EmitEvents } from '@btcdirect/shared/src/components/types';
import { onMounted, onUnmounted, ref } from 'vue';

const emit = defineEmits([ EmitEvents.FOCUSED, EmitEvents.BLURRED, EmitEvents.UPDATED ]);

const active = ref<boolean>(false);

const dropped = (event: DragEvent): void => {
    deactivate();
    emit(EmitEvents.UPDATED, Array.from(event.dataTransfer.files));
};

const activate = (): void => {
    active.value = true;
    emit(EmitEvents.FOCUSED);
};

const deactivate = (): void => {
    active.value = false;
    emit(EmitEvents.BLURRED);
};

const events = [ 'dragenter', 'dragover', 'dragleave', 'drop' ];

onMounted(() => {
    events.forEach((event) => {
        document.body.addEventListener(event, preventDefaults);
    });
});

onUnmounted(() => {
    events.forEach((event) => {
        document.body.removeEventListener(event, preventDefaults);
    });
});

function preventDefaults(event: Event): void {
    event.preventDefault();
}
</script>

<style scoped>
.file-drop-zone {
    cursor: pointer;
}
</style>
